'use es6';

import { MEETING_EVENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const MeetingEvent = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated('CRM:ILSFilters:ActivityFilters'),
  objectTypeId: MEETING_EVENT_TYPE_ID,
  referenceObjectType: 'MEETING_EVENT_PROPERTIES'
});
export default MeetingEvent;